import { ValidationResult } from '@/utils/rosterValidation'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { AlertCircle, CheckCircle2 } from 'lucide-react'

interface ValidationSummaryProps {
  validationResult: ValidationResult
  parsedDataLength: number
}

export function ValidationSummary({
  validationResult,
  parsedDataLength,
}: ValidationSummaryProps) {
  return (
    <div className='space-y-3'>
      {validationResult.errors.length > 0 && (
        <Alert variant='destructive'>
          <AlertCircle className='h-4 w-4' />
          <AlertTitle className='text-sm font-semibold'>
            Validation Errors ({validationResult.errors.length})
          </AlertTitle>
          <AlertDescription>
            <div className='max-h-[200px] overflow-y-auto mt-2 pr-2'>
              <ul className='list-disc list-inside space-y-1 text-sm'>
                {validationResult.errors.map((error, index) => (
                  <li key={index}>
                    Row {error.row - 1}: {error.message}
                  </li>
                ))}
              </ul>
            </div>
          </AlertDescription>
        </Alert>
      )}

      {validationResult.warnings.length > 0 && (
        <Alert>
          <AlertCircle className='h-4 w-4 text-yellow-500' />
          <AlertTitle className='text-sm font-semibold'>
            Warnings ({validationResult.warnings.length})
          </AlertTitle>
          <AlertDescription>
            <div className='max-h-[200px] overflow-y-auto mt-2 pr-2'>
              <ul className='list-disc list-inside space-y-1 text-sm'>
                {validationResult.warnings.map((warning, index) => (
                  <li key={index}>
                    Row {warning.row - 1}: {warning.message}
                  </li>
                ))}
              </ul>
            </div>
          </AlertDescription>
        </Alert>
      )}

      {validationResult.isValid &&
        validationResult.errors.length === 0 && (
          <Alert className='border-green-200 bg-green-50'>
            <CheckCircle2 className='h-4 w-4 text-green-500' />
            <AlertTitle className='text-sm font-semibold text-green-800'>
              Validation Passed
            </AlertTitle>
            <AlertDescription className='text-green-700'>
              Ready to send {parsedDataLength} invitation(s)
            </AlertDescription>
          </Alert>
        )}
    </div>
  )
}

